const LANGUAGE_CODE_MAP: Record<string, string> = { es_CL: 'es-CL' };
const mapLanguageCodeForTranslations = (language: string) => LANGUAGE_CODE_MAP[language] ?? language;
export default mapLanguageCodeForTranslations;
